//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { isString } from 'lodash';
import { gzip } from 'pako';
export class ApiClientConfig {
  public defaultHeaders: { [key: string]: any } = {};
}

export class BaseApiClient {
  private apiClientConfig: ApiClientConfig;

  constructor(apiClientConfig: ApiClientConfig) {
    this.apiClientConfig = apiClientConfig;
  }

  protected getBaseUrl(_: string, baseUrl = urlReplacer): string {
    return baseUrl;
  }

  protected transformOptions(requestConfig: RequestInit): Promise<RequestInit> {
    requestConfig.credentials = 'include';

    if (requestConfig.headers == null) requestConfig.headers = new Headers();

    if (requestConfig.body != null && isString(requestConfig.body)) {
      requestConfig.body = gzip(requestConfig.body as string);
      Reflect.set(requestConfig.headers, 'Content-Encoding', 'gzip');
    }

    for (const headerKey in this.apiClientConfig.defaultHeaders) {
      Reflect.set(requestConfig.headers, headerKey, this.apiClientConfig.defaultHeaders[headerKey]);
    }

    return Promise.resolve(requestConfig);
  }

  protected async transformResult<T>(
    url: string,
    response: Response,
    processFn: (r: Response) => Promise<T>
  ): Promise<T> {
    return processFn(response).catch((ex) => {
      if (
        ex != null &&
        // @ts-ignore
        ApiException.isApiException(ex) &&
        ex.response != null &&
        ex.response.length > 0
      ) {
        if (ex.status === 204) {
          return null as unknown as T;
        }
        // @ts-ignore
        ex.result = JSON.parse(ex.response, this.jsonParseReviver);
      }
      throw ex;
    });
  }
}

export class Client extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    invalidate(): Promise<void> {
        let url_ = this.baseUrl + "/Admin/Invalidate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInvalidate(_response));
        });
    }

    protected processInvalidate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add analytics log
     * @param body (optional) 
     * @return Success
     */
    addAnalyticsEvent(body: AddAnalyticsEventRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Analytics/AddAnalyticsEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddAnalyticsEvent(_response));
        });
    }

    protected processAddAnalyticsEvent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get campaigns
     * @return Success
     */
    getCampaigns(): Promise<Campaign[]> {
        let url_ = this.baseUrl + "/Campaigns/GetCampaigns";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCampaigns(_response));
        });
    }

    protected processGetCampaigns(response: Response): Promise<Campaign[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Campaign[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Campaign[]>(null as any);
    }

    /**
     * Start campaign
     * @param body (optional) 
     * @return Success
     */
    startCampaign(body: ChangeCampaignRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Campaigns/StartCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStartCampaign(_response));
        });
    }

    protected processStartCampaign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Stop campaign
     * @param body (optional) 
     * @return Success
     */
    stopCampaign(body: ChangeCampaignRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Campaigns/StopCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStopCampaign(_response));
        });
    }

    protected processStopCampaign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update campaign
     * @param body (optional) 
     * @return Success
     */
    updateCampaign(body: SaveCampaignRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Campaigns/UpdateCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCampaign(_response));
        });
    }

    protected processUpdateCampaign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Set campaigns priorities
     * @param body (optional) 
     * @return Success
     */
    setCampaignsPriorities(body: CampaignPriority[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Campaigns/SetCampaignsPriorities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetCampaignsPriorities(_response));
        });
    }

    protected processSetCampaignsPriorities(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add/remove sites in campaign
     * @param body (optional) 
     * @return Success
     */
    updateCampaignSites(body: ChangeCampaignSitesRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Campaigns/UpdateCampaignSites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCampaignSites(_response));
        });
    }

    protected processUpdateCampaignSites(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Archive campaign
     * @param body (optional) 
     * @return Success
     */
    archiveCampaign(body: ChangeCampaignRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Campaigns/ArchiveCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveCampaign(_response));
        });
    }

    protected processArchiveCampaign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Restore archived campaign
     * @param body (optional) 
     * @return Success
     */
    restoreCampaign(body: ChangeCampaignRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Campaigns/RestoreCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRestoreCampaign(_response));
        });
    }

    protected processRestoreCampaign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Export campaign performance report in CSV format
     * @param campaignId (optional) 
     * @return Success
     */
    exportPerformanceReport(campaignId: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Campaigns/ExportPerformanceReport?";
        if (campaignId === null)
            throw new Error("The parameter 'campaignId' cannot be null.");
        else if (campaignId !== undefined)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportPerformanceReport(_response));
        });
    }

    protected processExportPerformanceReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get a list of regions
     * @return Success
     */
    getRegions(): Promise<Region[]> {
        let url_ = this.baseUrl + "/Regions/GetRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRegions(_response));
        });
    }

    protected processGetRegions(response: Response): Promise<Region[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Region[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Region[]>(null as any);
    }

    /**
     * Get a list of countries
     * @return Success
     */
    getCountries(): Promise<Country[]> {
        let url_ = this.baseUrl + "/Regions/GetCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCountries(_response));
        });
    }

    protected processGetCountries(response: Response): Promise<Country[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Country[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Country[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCampaignCountries(body: UpdateCampaignCountries | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Regions/UpdateCampaignCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCampaignCountries(_response));
        });
    }

    protected processUpdateCampaignCountries(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get resources
     * @return Success
     */
    getResources(): Promise<ResourceType[]> {
        let url_ = this.baseUrl + "/Resources/GetResources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetResources(_response));
        });
    }

    protected processGetResources(response: Response): Promise<ResourceType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceType[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceType[]>(null as any);
    }

    /**
     * Create resource
     * @param body (optional) 
     * @return Success
     */
    createResource(body: ResourceType | undefined): Promise<CreateResourceResponse> {
        let url_ = this.baseUrl + "/Resources/CreateResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateResource(_response));
        });
    }

    protected processCreateResource(response: Response): Promise<CreateResourceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateResourceResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateResourceResponse>(null as any);
    }

    /**
     * Update resource
     * @param body (optional) 
     * @return Success
     */
    updateResource(body: ResourceType | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Resources/UpdateResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateResource(_response));
        });
    }

    protected processUpdateResource(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add text resource to campaign or update it's content
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateTextResource(body: ChangeTextResourceRequest | undefined): Promise<Resource> {
        let url_ = this.baseUrl + "/Resources/CreateOrUpdateTextResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateOrUpdateTextResource(_response));
        });
    }

    protected processCreateOrUpdateTextResource(response: Response): Promise<Resource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Resource;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Resource>(null as any);
    }

    /**
     * Add file resource to campaign or update it
     * @param version (optional) 
     * @param file (optional) 
     * @param resourceId (optional) 
     * @param languageCode (optional) 
     * @param campaignId (optional) Campaign Id
     * @return Success
     */
    createOrUpdateFileResource(version: number | undefined, file: FileParameter | undefined, resourceId: number | undefined, languageCode: string | undefined, campaignId: string | undefined): Promise<Resource> {
        let url_ = this.baseUrl + "/Resources/CreateOrUpdateFileResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (version === null || version === undefined)
            throw new Error("The parameter 'version' cannot be null.");
        else
            content_.append("Version", version.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (resourceId === null || resourceId === undefined)
            throw new Error("The parameter 'resourceId' cannot be null.");
        else
            content_.append("ResourceId", resourceId.toString());
        if (languageCode === null || languageCode === undefined)
            throw new Error("The parameter 'languageCode' cannot be null.");
        else
            content_.append("LanguageCode", languageCode.toString());
        if (campaignId === null || campaignId === undefined)
            throw new Error("The parameter 'campaignId' cannot be null.");
        else
            content_.append("CampaignId", campaignId.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateOrUpdateFileResource(_response));
        });
    }

    protected processCreateOrUpdateFileResource(response: Response): Promise<Resource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Resource;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Resource>(null as any);
    }

    /**
     * Get resources for campaign
     * @param campaignId (optional) 
     * @return Success
     */
    getCampaignResources(campaignId: string | undefined): Promise<CampaignResourceResponse[]> {
        let url_ = this.baseUrl + "/Resources/GetCampaignResources?";
        if (campaignId === null)
            throw new Error("The parameter 'campaignId' cannot be null.");
        else if (campaignId !== undefined)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCampaignResources(_response));
        });
    }

    protected processGetCampaignResources(response: Response): Promise<CampaignResourceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CampaignResourceResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CampaignResourceResponse[]>(null as any);
    }

    /**
     * Delete campaign resource
     * @param body (optional) 
     * @return Success
     */
    deleteCampaignResource(body: DeleteCampaignResourceRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Resources/DeleteCampaignResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteCampaignResource(_response));
        });
    }

    protected processDeleteCampaignResource(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get locales
     * @return Success
     */
    getLanguages(): Promise<Language[]> {
        let url_ = this.baseUrl + "/Resources/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLanguages(_response));
        });
    }

    protected processGetLanguages(response: Response): Promise<Language[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Language[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Language[]>(null as any);
    }

    /**
     * Get resource preview
     * @param body (optional) 
     * @return Success
     */
    getResourcePreview(body: CampaignResourcePreviewRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Resources/GetResourcePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetResourcePreview(_response));
        });
    }

    protected processGetResourcePreview(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Delete resource type
     * @param body (optional) 
     * @return Success
     */
    deleteResourceType(body: DeleteResourceTypeRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Resources/DeleteResourceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteResourceType(_response));
        });
    }

    protected processDeleteResourceType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Activate resource version
     * @param body (optional) 
     * @return Success
     */
    activateResourceVersion(body: ChangeResourceVersionRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Resources/ActivateResourceVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivateResourceVersion(_response));
        });
    }

    protected processActivateResourceVersion(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deactivate resource version
     * @param body (optional) 
     * @return Success
     */
    deactivateResourceVersion(body: ChangeResourceVersionRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Resources/DeactivateResourceVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeactivateResourceVersion(_response));
        });
    }

    protected processDeactivateResourceVersion(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get site parameter types
     * @return Success
     */
    getSiteParameterTypes(): Promise<string[]> {
        let url_ = this.baseUrl + "/SiteParameters/GetSiteParameterTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSiteParameterTypes(_response));
        });
    }

    protected processGetSiteParameterTypes(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Set site parameters
     * @param body (optional) 
     * @return Success
     */
    setSiteParameters(body: SetSiteParametersRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/SiteParameters/SetSiteParameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetSiteParameters(_response));
        });
    }

    protected processSetSiteParameters(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create site parameter
     * @param body (optional) 
     * @return Success
     */
    createSiteParameter(body: SaveSiteParameterRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/SiteParameters/CreateSiteParameter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSiteParameter(_response));
        });
    }

    protected processCreateSiteParameter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update site parameter
     * @param body (optional) 
     * @return Success
     */
    updateSiteParameter(body: SaveSiteParameterRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/SiteParameters/UpdateSiteParameter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSiteParameter(_response));
        });
    }

    protected processUpdateSiteParameter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete site parameter
     * @param body (optional) 
     * @return Success
     */
    deleteSiteParameter(body: DeleteSiteParameterRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/SiteParameters/DeleteSiteParameter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSiteParameter(_response));
        });
    }

    protected processDeleteSiteParameter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get sites
     * @return Success
     */
    getSites(): Promise<Site[]> {
        let url_ = this.baseUrl + "/Sites/GetSites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSites(_response));
        });
    }

    protected processGetSites(response: Response): Promise<Site[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Site[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Site[]>(null as any);
    }

    /**
     * Get user resources
     * @param body (optional) 
     * @return Success
     */
    getUserResources(body: GetUserResourcesRequest | undefined): Promise<UserResource[]> {
        let url_ = this.baseUrl + "/UserResources/GetUserResources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserResources(_response));
        });
    }

    protected processGetUserResources(response: Response): Promise<UserResource[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserResource[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserResource[]>(null as any);
    }

    /**
     * Get wrappers
     * @return Success
     */
    getWrappers(): Promise<Wrapper[]> {
        let url_ = this.baseUrl + "/Wrappers/GetWrappers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWrappers(_response));
        });
    }

    protected processGetWrappers(response: Response): Promise<Wrapper[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Wrapper[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Wrapper[]>(null as any);
    }

    /**
     * Add wrapper
     * @param body (optional) 
     * @return Success
     */
    addWrapper(body: CreateWrapperRequest | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Wrappers/AddWrapper";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddWrapper(_response));
        });
    }

    protected processAddWrapper(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Update wrapper
     * @param body (optional) 
     * @return Success
     */
    updateWrapper(body: Wrapper | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Wrappers/UpdateWrapper";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateWrapper(_response));
        });
    }

    protected processUpdateWrapper(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete wrapper
     * @param body (optional) 
     * @return Success
     */
    deleteWrapper(body: DeleteWrapperRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Wrappers/DeleteWrapper";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteWrapper(_response));
        });
    }

    protected processDeleteWrapper(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface AddAnalyticsEventRequest {
    userResourceId: string | undefined;
    eventTypeId: number;
    userId: string | undefined;
    targetUrl: string | undefined;
    browserGuid: string | undefined;
}

export interface Campaign {
    id: string | undefined;
    name: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    isActive: boolean;
    priority: number;
    sites: Site[] | undefined;
    countries: Country[] | undefined;
    visibility: VisibilityTypes;
    audience: number;
    apiName: string | undefined;
    canActivate: boolean;
    isArchived: boolean;
}

export interface CampaignPriority {
    campaignId: string | undefined;
    priority: number;
}

export interface CampaignResourceItem {
    languageCode: string | undefined;
    wrapperId: number | undefined;
    content: string | undefined;
    renderedContent: string | undefined;
    version: number;
    cta: string | undefined;
    isActive: boolean;
}

export interface CampaignResourcePreviewRequest {
    campaignId: string | undefined;
    languageCode: string | undefined;
    resourceId: number;
    rawResource: string | undefined;
    wrapperId: number | undefined;
}

export interface CampaignResourceResponse {
    campaignId: string | undefined;
    resource: ResourceType;
    items: CampaignResourceItem[] | undefined;
}

export interface ChangeCampaignRequest {
    /** Campaign Id */
    campaignId: string;
}

export interface ChangeCampaignSitesRequest {
    siteIds: string[] | undefined;
    campaignId: string | undefined;
}

export interface ChangeResourceVersionRequest {
    campaignId: string | undefined;
    resourceId: number;
    languageCode: string | undefined;
    version: number;
}

export interface ChangeTextResourceRequest {
    /** Campaign Id */
    campaignId: string;
    resourceId: number;
    languageCode: string | undefined;
    wrapperId: number | undefined;
    /** Content */
    content: string;
    version: number;
    cta: string | undefined;
}

/** 1 = Image 2 = URL 3 = Html */
export type ContentType = 1 | 2 | 3;

export interface Country {
    alpha2: string | undefined;
    name: string | undefined;
}

export interface CreateResourceResponse {
    id: number;
}

export interface CreateWrapperRequest {
    name: string | undefined;
    content: string | undefined;
}

export interface DeleteCampaignResourceRequest {
    /** Campaign Id */
    campaignId: string;
    /** Resource Id */
    resourceId: number;
    languageCode: string | undefined;
    version: number | undefined;
}

export interface DeleteResourceTypeRequest {
    resourceTypeId: number;
}

export interface DeleteSiteParameterRequest {
    siteId: string | undefined;
    parameterTypeId: string | undefined;
}

export interface DeleteWrapperRequest {
    wrapperId: number;
}

export interface GetUserResourcesRequest {
    siteId: string | undefined;
    userId: string | undefined;
    sessionId: string | undefined;
    campaignId: string | undefined;
    locale: string | undefined;
    /** Resource names */
    resourceNames: string[];
    browserGuid: string | undefined;
}

export interface Language {
    code: string | undefined;
    isDefault: boolean;
}

export interface Region {
    id: string | undefined;
    name: string | undefined;
    countries: Country[] | undefined;
}

export interface Resource {
    campaignId: string | undefined;
    resourceTypeId: number;
    languageCode: string | undefined;
    content: string | undefined;
    wrapperId: number | undefined;
    version: number;
    cta: string | undefined;
    isActive: boolean;
}

export interface ResourceType {
    id: number;
    name: string | undefined;
    variableName: string | undefined;
    hintText: string | undefined;
    contentType: ContentType;
}

export interface SaveCampaignRequest {
    id: string | undefined;
    name: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    visibility: VisibilityTypes;
    apiName: string | undefined;
}

export interface SaveSiteParameterRequest {
    siteId: string | undefined;
    parameterTypeId: string | undefined;
    parameterValue: string | undefined;
}

export interface SetSiteParametersRequest {
    siteId: string | undefined;
    parametersToUpdate: SiteParameter[] | undefined;
    parameterNamesToDelete: string[] | undefined;
}

export interface Site {
    id: string | undefined;
    name: string | undefined;
    description: string | undefined;
    readonly parameters: SiteParameter[] | undefined;
    internalId: number;
}

export interface SiteParameter {
    name: string | undefined;
    value: string | undefined;
}

export interface UpdateCampaignCountries {
    campaignId: string | undefined;
    countryCodes: string[] | undefined;
}

export interface UserResource {
    resourceId: string | undefined;
    value: string | undefined;
    version: number;
}

/** 1 = CampaignMembers 2 = Anonymous 3 = LoggedIn 4 = Everyone */
export type VisibilityTypes = 1 | 2 | 3 | 4;

export interface Wrapper {
    id: number;
    name: string | undefined;
    content: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

const urlReplacer = '<BASE_URL>';